import { Link } from "@tanstack/react-router";
import { Lock } from "lucide-react";

export function Footer() {
  return (
    <footer className="mt-auto border-border/60 border-t bg-background/95 backdrop-blur-sm">
      <div className="container mx-auto max-w-5xl px-4 py-6 pb-12 sm:pb-6">
        {/* Üst Kısım: Logo, Menü ve Sosyal Medya */}
        <div className="flex flex-col items-center justify-between gap-5 text-center md:flex-row md:text-left">
          {/* Logo & Telif */}
          <div className="flex items-center gap-2.5">
            <Link to="/" className="font-extrabold text-sm tracking-tight">
              <span className="text-primary">Atalay</span>
              <span className="text-foreground">TheCoach</span>
            </Link>
            <span className="text-muted-foreground/60 text-xs">•</span>
            <span className="text-muted-foreground text-xs">
              © {new Date().getFullYear()}
            </span>
          </div>

          {/* Menü Linkleri (Mobil Uyumlu & Dokunmatik Dostu) */}
          <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-2 text-xs">
            <Link
              to="/essay"
              className="py-0.5 text-muted-foreground transition-colors hover:text-foreground"
            >
              İçerikler
            </Link>
            <Link
              to="/forum"
              className="py-0.5 text-muted-foreground transition-colors hover:text-foreground"
            >
              Forum
            </Link>
            <Link
              to="/coachs"
              className="py-0.5 text-muted-foreground transition-colors hover:text-foreground"
            >
              Koçluk
            </Link>
            <Link
              to="/privacy"
              search={{ tab: "distance-sales" }}
              className="py-0.5 font-medium text-muted-foreground transition-colors hover:text-primary"
            >
              Mesafeli Satış
            </Link>
            <Link
              to="/privacy"
              search={{ tab: "delivery-return" }}
              className="py-0.5 font-medium text-muted-foreground transition-colors hover:text-primary"
            >
              Teslimat & İade
            </Link>
            <Link
              to="/privacy"
              search={{ tab: "kvkk" }}
              className="py-0.5 text-muted-foreground transition-colors hover:text-primary"
            >
              KVKK & Gizlilik
            </Link>
          </nav>

          {/* Sosyal Medya İkonları */}
          <div className="flex items-center justify-center space-x-3.5">
            <a
              href="https://instagram.com/atalaythecoach"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram"
              className="flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-primary active:scale-95"
            >
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7.75 2A5.75 5.75 0 0 0 2 7.75v8.5A5.75 5.75 0 0 0 7.75 22h8.5A5.75 5.75 0 0 0 22 16.25v-8.5A5.75 5.75 0 0 0 16.25 2h-8.5zm0 1.5h8.5A4.25 4.25 0 0 1 20.5 7.75v8.5A4.25 4.25 0 0 1 16.25 20.5h-8.5A4.25 4.25 0 0 1 3.5 16.25v-8.5A4.25 4.25 0 0 1 7.75 3.5zm4.25 2.75a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 1.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm5.25.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
              </svg>
            </a>
            <a
              href="https://youtube.com/@atalaythecoach"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="YouTube"
              className="flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-primary active:scale-95"
            >
              <svg className="h-4 w-4" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a
              href="mailto:info@atalaythecoach.com"
              aria-label="E-posta"
              className="flex h-8 w-8 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:text-primary active:scale-95"
            >
              <svg
                className="h-4 w-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </a>
          </div>
        </div>

        {/* Alt Kısım: Güvenlik & İyzico Logo Bandı */}
        <div className="mt-5 flex flex-col items-center justify-between gap-3.5 border-border/40 border-t pt-4 sm:flex-row">
          <div className="flex items-center gap-1.5 text-center text-[11px] text-muted-foreground sm:text-left">
            <Lock className="h-3 w-3 shrink-0 text-primary" />
            <span>256-Bit SSL ve İyzico ile 3D Secure Güvenli Ödeme</span>
          </div>

          <div className="flex max-w-full items-center justify-center overflow-hidden rounded-lg border border-border/60 bg-white/95 px-3 py-1.5 shadow-2xs dark:bg-card/90">
            <img
              src="/iyzico-logo-pack/footer_iyzico_ile_ode/Colored/logo_band_colored.svg"
              alt="İyzico ile Öde, Visa, Mastercard, Troy, Amex"
              className="h-5 w-auto max-w-[260px] object-contain sm:max-w-[280px]"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </footer>
  );
}
